import { useState, useEffect } from "react";

// This custom hook takes a ref as an argument and returns the width of the element
export function useWidth(ref) {
  // Initialize the state with the initial width of the element
  const [width, setWidth] = useState(ref.current ? ref.current.offsetWidth : 0);

  // This function updates the width state when the element is resized
  const updateWidth = () => {
    setWidth(ref.current.offsetWidth);
  };

  // This effect adds an event listener for the resize event and cleans up after unmounting
  useEffect(() => {
    updateWidth();
    window.addEventListener("resize", updateWidth);
    return () => {
      window.removeEventListener("resize", updateWidth);
    };
    // eslint-disable-next-line
  }, []);

  // Return the width state
  return width;
}

export default useWidth;
